export default __webpack_public_path__ + "static/media/Politica_Proteccion_Datos.a0fc4691.pdf";